/** Plain words for the training numbers (UX review 0.9.12): every metric a rider sees can be tapped for one
 * sentence of explanation. One place, so the same word means the same thing on every screen. */
export const TERMS = {
  load: "How hard a ride was for your body: about 100 for one hour as hard as you can hold, 50 for an hour of easy riding. Your watch's own training load uses another scale.",
  fitness:
    "Your fitness: the average load of the last six weeks. It rises slowly with steady training and is what the plan builds.",
  fatigue:
    "Your fatigue: the average load of the last week. It rises fast after hard days and falls with rest.",
  freshness:
    "Freshness = fitness minus fatigue. Negative while you train hard, positive after easy days; race day wants it slightly positive.",
  easyLimit:
    "Your easy limit: the heart rate your easy, long and back-to-back rides stay under. Below it you can ride for many hours and still train fat burning.",
  readiness:
    "Today's readiness from your sleep, heart-rate variability, resting heart rate, how you feel and recent training: 100 is fully fresh.",
  raceReadiness:
    "How ready you are for your race, 1 to 100: aerobic fitness, durability on long and back-to-back days, race-like riding, and your setup. It grows over months.",
  hrCap:
    "Keep your heart rate under this number for the whole session (short steep climbs: walk or spin, don't push).",
  lt1: "LT1, the first lactate threshold: the top of easy riding. Below it you can ride for many hours; your easy limit sits here.",
  ftp: "FTP, functional threshold power: the power in watts you can hold for about an hour. Power targets are set from it.",
  lthr: "LTHR, lactate threshold heart rate: your heart rate at the effort you can hold for about an hour. Your heart-rate zones are set from it.",
  intensity:
    "Easy, tempo and hard: how much of the ride was under your easy limit, around threshold and above it.",
} as const;

export type TermKey = keyof typeof TERMS;

/** Abbreviations the coach writes in its texts, explained where they appear (BR-134). */
export const ABBREVIATIONS: Record<string, TermKey> = { LT1: "lt1", FTP: "ftp", LTHR: "lthr" };
